import React, {useEffect, useState} from "react";

function ButtonChooser({items, defaultValue, onChange, label, unit = ""}) {

    const transformValues = () => {
        return items.map(value => ({
            value: value,
            active: defaultValue === value
        }));
    }

    const [values, setValues] = useState(transformValues());

    useEffect(() => {
        setValues(transformValues());
    }, [items]);

    const updateValues = (newValue) => {
        setValues([...values].map(v => ({
            value: v.value,
            active: newValue === v.value
        })));
    }

    const valueButtonClickHandler = (chosenValue) => {
        updateValues(chosenValue.value);
        onChange(chosenValue.value);
    };

    let buttons = values.map(buttonValue => (
        <button key={buttonValue.value}
                type="button"
                onClick={() => valueButtonClickHandler(buttonValue)}
                className={"calc__period-btn" + (buttonValue.active ? " calc__period-btn--active" : "")}>
            {buttonValue.value}{unit ? " " + unit : ""}
        </button>
    ));

    return (
        <div className="calc__form-item">
            <div className="calc__period-header">
                <span className="calc__period-title">{label}</span>
            </div>
            <div className="calc__period-row">
                {buttons}
            </div>
        </div>
    );
}

export default ButtonChooser;
